import { Component, OnInit, OnDestroy, Injector, runInInjectionContext, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Subscription, firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-north-america-2',
    templateUrl: './north-america-2.component.html',
    styleUrls: ['./north-america-2.component.scss'],
    standalone: false
})
export class NorthAmerica2Component implements OnInit, OnDestroy {
    zones = [
        {
            id: '5-2-1',
            number: 57,
            class: 'jamaica',
            locked: true,
            active: false,
            hover: false
        },
        {
            id: '5-2-2',
            number: 58,
            class: 'haiti',
            locked: true,
            active: false,
            hover: false
        },
        {
            id: '5-2-3',
            number: 59,
            class: 'dominican',
            locked: true,
            active: false,
            hover: false
        },
        {
            id: '5-2-4',
            number: 60,
            class: 'theBahamas',
            locked: true,
            active: false,
            hover: false
        }
    ];

    public activeZone = 1;
    user: any;
    openZones: number;
    tick2Quiz: boolean = true;
    isAdmin: boolean = false;
    private subscriptions: Subscription = new Subscription();

    activeContinent: number;

    quizLevel: any;
    plane: any = {
        position: 1
    };
    loading = true;
    adminUserData;

    constructor(
        private router: Router, 
        private afs: AngularFirestore,
        private injector: Injector,
        private cdr: ChangeDetectorRef
    ) { }

    async ngOnInit() {
        this.tick2Quiz = true;
        const user = JSON.parse(localStorage.getItem('currentUser'));

        try {
            const userDoc: any = await runInInjectionContext(this.injector, () => 
                firstValueFrom(this.afs.collection('userData').doc(user.uid).get())
            );

            if (userDoc.exists) {
                const userData = userDoc.data();
                this.adminUserData = JSON.parse(localStorage.getItem('quranera_admin_userData'));

                if (this.adminUserData) {
                    this.isAdmin = true;
                    userData.activeLevel = '9-9-9';
                }

                this.user = userData;
                if (userData.activities && userData.activities["4-2-1"]) {
                    this.tick2Quiz = false;
                }

                this.activeZone = this.adminUserData ? 99 : parseInt(userData.activeLevel.split('-')[1], 10);
                this.activeContinent = this.isAdmin ? 4 : parseInt(userData.activeLevel.split('-')[0], 10);
                if (this.activeZone > 3) {
                    this.openZones = 5;
                } else {
                    this.openZones = parseInt(userData.activeLevel.split('-')[2], 10);
                }
                this.plane.position = this.openZones;

                if (userData.quizLevel) {
                    this.quizLevel = userData.quizLevel;
                }
                if (this.adminUserData) {
                    this.quizLevel = 100;
                }
                this.remapZones();
                this.cdr.detectChanges();
            }
        } catch (error) {
            console.error("Error loading user data:", error);
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    goQuiz() {
        // this.showNotification = true;
        // return;
        if (this.quizLevel >= 11) {
            this.router.navigate(['/game/quiz-activity/5-1']);
        }
    }

    remapZones() {
        this.zones = [
            {
                id: '5-2-1',
                number: 57,
                class: 'jamaica',
                locked: true,
                active: false,
                hover: false
            },
            {
                id: '5-2-2',
                number: 58,
                class: 'haiti',
                locked: true,
                active: false,
                hover: false
            },
            {
                id: '5-2-3',
                number: 59,
                class: 'dominican',
                locked: true,
                active: false,
                hover: false
            },
            {
                id: '5-2-4',
                number: 60,
                class: 'theBahamas',
                locked: true,
                active: false,
                hover: false
            }
        ];
        this.zones.map(zone => {
            if (this.activeContinent < 4) return;

            if (!this.user.activities[zone.id]) {
                zone.locked = this.isAdmin ? false : true;
            } else {
                zone.locked = this.isAdmin ? false : false;
            }
            if (this.user.activeLevel === zone.id && this.user.activities[zone.id]) {
                zone.active = this.isAdmin ? false : true;
            }
        });
    }

    mouseEnter(zone) {
        const audio = document.getElementById('continentHover') as HTMLAudioElement;
        audio.pause();
        audio.currentTime = 0;
        audio.play();
        zone.hover = true;
    }

    mouseLeave(zone) {
        zone.hover = false;
    }

    selectZone(zone) {
        if (!zone.locked) {
            const audio = document.getElementById('continentClick') as HTMLAudioElement;
            audio.play();
            setTimeout(() => {
                this.router.navigate(['/game/activity-list/' + zone.id]);
            }, 1000);
        }
    }

    playBgAudio() {
        let audio = <HTMLAudioElement>document.getElementById('bgAudio');
        audio.play();
    }

    playIntroductionAudio() {
        let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
        audio.play();
    }

    instructionLoaded() {
        if (this.loading) {
            this.loading = false;
            let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
            audio.play();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.loading) {
                this.instructionLoaded();
            }
        }, 2000);
    }

    haveAccess(activityLevel) {
        if (this.adminUserData) return true;

        if (this.user == undefined) return false;
        if (!this.user['activities'][activityLevel + '-1']
            && !this.user['activities'][activityLevel + '-2']
            && !this.user['activities'][activityLevel + '-3']
            && !this.user['activities'][activityLevel + '-4']
        ) return false;

        for (var a = 1; a <= 4; a++) {
            for (var i = 1; i <= 15; i++) {
                if (this.user["activities"][activityLevel + '-' + a.toString()]) {
                    if (this.user["activities"][activityLevel + '-' + a.toString()][i.toString()]) return true;
                }
            }
        }

        return false;
    }
}

